import {IMixerChannel} from '../channel-collection'

export const itemLimit = 250
export const defaultStepSize = 0.001
export const defaultCutStepSize = 0.01

export const defaultChannelValue: IMixerChannel['value'] = {
  isInitialized: true,
  sort: 1,
  cut: {
    min: defaultCutStepSize,
    max: 1,
  },
}

export const defaultLimitChannels: IMixerChannel[] = [
  {
    descriptor: {
      kind: 'limit',
      label: 'limit: sort score',
      sourcePath: 'sortScore',
      range: {min: -1, max: 1},
    },
    stepSize: defaultStepSize,
    cutStepSize: defaultCutStepSize,
    value: {
      isInitialized: true,
      // mute: true,
      sort: 0,
      cut: {min: defaultCutStepSize, max: 1},
    },
  },
  {
    descriptor: {
      kind: 'limit',
      label: 'limit: list position',
      sourcePath: 'position',
      range: {min: 1, max: itemLimit},
    },
    stepSize: 1,
    isInteger: true,
    value: {
      isInitialized: true,
      mute: true,
      sort: 0,
      cut: {min: 1, max: itemLimit},
    },
  },
]
